import styled from 'styled-components';
import { Input, Select, DatePicker, Button } from 'antd';

export const StyledFlexDiv = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
`;

export const StyledInput = styled(Input)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  display: block;
  margin-top: ${({ theme }) => theme.spacing.space_2};

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
  }
`;

export const StyledFieldRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_2};
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledSectionHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-top: ${({ theme }) => theme.spacing.space_4};
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
  padding-bottom: ${({ theme }) => theme.spacing.space_2};
  border-bottom: 1px solid ${({ theme }) => theme.palette.greys.grey};
`;

export const StyledAddButton = styled(Button)`
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;
